(function() {
    'use strict';

    angular
        .module('jotApp')
        .controller('LicencesCodeDetailController', LicencesCodeDetailController);

    LicencesCodeDetailController.$inject = ['$q', '$state', '$uibModal', 'LicenceCode', 'Vendor', 'pagingParams', 'paginationConstants'];

    function LicencesCodeDetailController($q, $state, $uibModal, LicenceCode, Vendor, pagingParams, paginationConstants) {
        var vm = this;
        vm.licences = [];
        vm.vendors = [];
        vm.domains = [];

        vm.filter = {};
        vm.status = -1;
        vm.vendor = [];

        vm.domain = [];

        vm.charToSearch = pagingParams.search;
        vm.domainAble;

        var filter = localStorage.getItem("licence-code-detail");

        if(filter != null && filter != "null" && filter != undefined){
            vm.filter = JSON.parse(filter);
            if (Object.keys(vm.filter).length > 0) {
                vm.status = vm.filter.status ? vm.filter.status : "-1";
                vm.vendor = vm.filter.vendor;
                vm.domain = vm.filter.domain;

            }
        }

        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.changePageSize = changePageSize;
        vm.itemsPerPageChoose = paginationConstants.itemsPerPageChoose;
        vm.itemsPerPageChosen = $state.params.itemsPerPageChosen ? $state.params.itemsPerPageChosen : paginationConstants.itemsPerPage;

        vm.exportTable = exportTable;
        vm.loadAllToExport = loadAllToExport;

        Vendor.query(function (result) {
            var all = {
                id: -1,
                name: "All",
                link: null
            };
            vm.vendors = result;
            vm.vendors.unshift(all);
        });


        vm.loadAll = function(){

            var body = {
                page: pagingParams.page -1,
                size: vm.itemsPerPageChosen,
                id: vm.vendor.id == null || vm.vendor.id == undefined ? -1 : vm.vendor.id,
                status: vm.status,
                domainId : vm.domain.domainName == null || vm.domain.domainName == undefined || vm.domain.domainName === "All" ? "" : vm.domain.domainName,
                query: vm.charToSearch
            };

            LicenceCode.getByVendor(body, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.licences = [];
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.page = pagingParams.page;
                vm.licences = data;
            }

            function onError() {}
        };

        vm.addDomains = function () {
            var body = {
                page: 0,
                size: 1000,
            };
            LicenceCode.getDomains(body, onSuccess, onError)
            function onSuccess(data) {
                const all = {
                    domainName: "All"
                };
                vm.domains = data.map(function(x) {return{domainName: x.domainName}})
                vm.domains.unshift(all);
            }
            function onError() {}
        }

        function changePageSize() {
            if ((vm.queryCount / vm.itemsPerPageChosen) < pagingParams.page)
                vm.page = Math.ceil(vm.queryCount / vm.itemsPerPageChosen);
            transition();
        }

        function loadPage (page) {
            vm.page = page;
            vm.transition();
        }

        function transition(notify) {
            notify = notify === false ? notify : true;
            vm.filter.vendor = vm.vendor;
            vm.filter.status = vm.status;
            vm.filter.domain = vm.domain;
            localStorage.setItem("licence-code-detail", JSON.stringify(vm.filter));
            $state.transitionTo($state.$current, {
                page: vm.page,
                itemsPerPageChosen: vm.itemsPerPageChosen,
                id: vm.vendor.id == null || vm.vendor.id == undefined ? -1 : vm.vendor.id,
                status: vm.status,
                search: vm.charToSearch,
                domain : vm.domain.domainName == null || vm.domain.domainName == undefined || vm.domain.domainName === "All" ? "" : vm.domain.domainName,
                filter: vm.filter
            }, {notify: notify, location: "replace"});
        }

        vm.reloadLicences = function() {
            vm.filter.vendor = vm.vendor;
            vm.filter.status = vm.status;
            vm.filter.domain = vm.status == 1 ? {domainName: "All"} :vm.domain;
            vm.domain = vm.status == 1 ? {domainName: "All"} :vm.domain;
            vm.charToSearch = '',
            vm.domainAble = vm.status == 1;
            localStorage.setItem("licence-code-detail", JSON.stringify(vm.filter));
            vm.loadAll();
        };

        function loadAllToExport(){
            var body = {
                page: 0,
                size: 1000,
                id: vm.vendor.id == null || vm.vendor.id == undefined ? -1 : vm.vendor.id,
                status: vm.status,
                domainId : vm.domain.domainName == null || vm.domain.domainName == undefined || vm.domain.domainName === "All" ? "" : vm.domain.domainName,
            };

            LicenceCode.getByVendor(body, onSuccess, onError);

            function onSuccess(data) {vm.licences = data;}
            function onError() {}
        }

        function exportTable(type) {

            if (type == 'pdf') {
                $('#tableToExport').tableExport({
                    type: 'pdf',
                    pdfFontSize: '7',
                    escape: 'false',
                    size: {0: 70, 1: 80, 2: 100, 3: 100, 4: 100, 5: 100},
                    tableName: 'Licences Code'
                });
            } else if (type != null) {
                $('#tableToExport').tableExport({type: type, escape: 'false', tableName: 'Licences Code'});
            }

            vm.loadAll();
        }

        vm.change = function(id){
            $uibModal.open({
                templateUrl: 'app/admin/licences/change-object.html',
                controller: 'ChangeObjectController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    entity: ['LicenceCode', function (LicenceCode) {
                        return LicenceCode.get({id: id});
                    }]
                }
            }).result.then(function () {
                $state.go('licences-code-detail', null, {reload: true});
            });
        };

        vm.loadAll();
        vm.addDomains();
    }
})();
